import { Chain } from 'wagmi';
import { mainnet, goerli } from 'wagmi/chains';

import { isProd } from 'utils/env';

// falls back to dev
export const selectedChainId = isProd ? mainnet.id : goerli.id;

export const selectedChain: Chain = isProd ? mainnet : goerli;
